<template>
    <NotificationMessage :avatar="message.avatar"
        :text="'It\'s been 48 hours since you\'ve accepted the rental request and ' + message.customerName + ' still hasn\'t payed. The rental request has been cancelled.'"
    />

</template>

<script>
import NotificationMessage from '@/components/inbox/messagesCard/shared/NotificationMessage.vue';

export default {
    components: {
        NotificationMessage
    },
    props: {
        message: {
            type: Object
        }
    }
};
</script>
